const TILE_CONFIGS = [
  {
    label: 'offerWizard.StepCertificate.co2',
    value: 'co2',
    iconComponent: 'Co2Icon',
    urlValue: 'CO2',
  },
  {
    label: 'offerWizard.StepCertificate.proofOfOrigin',
    value: 'proofOfOrigin',
    iconComponent: 'ProofOfOriginIcon',
    urlValue: 'HKN',
  },
];

export default TILE_CONFIGS;
